import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { MacroCard } from "@/components/MacroCard";
import { Skeleton } from "@/components/ui/skeleton";

const SkeletonMacroCard = () => (
  <div className="flex-shrink-0 w-[300px] md:w-[380px] bg-card rounded-lg border border-border overflow-hidden">
    <Skeleton className="h-48 w-full" />
    <div className="p-4 space-y-3">
      <Skeleton className="h-5 w-3/4" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-2/3" />
      <div className="flex items-center gap-2 pt-2">
        <Skeleton className="h-6 w-6 rounded-full" />
        <Skeleton className="h-4 w-24" />
      </div>
    </div>
  </div>
);

export const MacroShowcaseSection = () => {
  const [macros, setMacros] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMacros = async () => {
      const {
        data,
        error
      } = await supabase.from("macros").select(`
          id,
          name,
          slug,
          short_desc,
          views_count,
          screenshot_url,
          public_profiles (
            username,
            full_name,
            verified,
            avatar_url
          ),
          macro_tags (tags (name))
        `).eq("is_published", true).eq("is_approved", true).order("created_at", {
        ascending: false
      }).limit(10);
      if (error) {
        console.error("Failed to fetch macros for showcase:", error);
      }
      if (data && !error) {
        const processedMacros = data.map((macro: any) => ({
          ...macro,
          tags: macro.macro_tags?.map((mt: any) => mt.tags.name) || []
        }));
        setMacros(processedMacros);
      }
      setIsLoading(false);
    };
    fetchMacros();
  }, []);
  // Triple the macros array for seamless infinite loop
  const displayMacros = macros.length > 0 ? [...macros, ...macros, ...macros] : [];
  return <section className="relative bg-muted/10 pb-32">
      <div className="container mx-auto px-4 max-w-7xl py-12">
        
      </div>
      
      {isLoading ? (
        <div className="relative overflow-hidden w-full">
          <div className="flex gap-4 animate-infinite-scroll-mobile md:animate-infinite-scroll" style={{ width: 'fit-content' }}>
            {[...Array(15)].map((_, index) => (
              <SkeletonMacroCard key={index} />
            ))}
          </div>
        </div>
      ) : macros.length === 0 ? (
        <div className="w-full text-center text-muted-foreground py-8">
          No published macros yet.
          <a href="/vault" className="ml-2 underline">Explore the vault</a>
        </div>
      ) : (
        <div className="relative overflow-hidden w-full">
          <div className="flex gap-4 animate-infinite-scroll-mobile md:animate-infinite-scroll" style={{ width: 'fit-content' }}>
            {displayMacros.map((macro, index) => (
              <div key={`${macro.id}-${index}`} className="flex-shrink-0 w-[300px] md:w-[380px]">
                <MacroCard 
                  id={macro.id} 
                  slug={macro.slug} 
                  name={macro.name} 
                  shortDesc={macro.short_desc || ""} 
                  ownerHandle={macro.public_profiles?.username || "unknown"} 
                  ownerDisplayName={macro.public_profiles?.full_name || macro.public_profiles?.username || "Unknown User"} 
                  ownerVerified={macro.public_profiles?.verified || false} 
                  riskScore="low" 
                  tags={macro.tags || []} 
                  viewsCount={macro.views_count || 0} 
                  screenshotUrl={macro.screenshot_url} 
                />
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Curved Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]">
        
      </div>
    </section>;
};